import {CustomerModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Reviews/CustomerModel';

export class TrekReviewModel {
    public id: number;
    public trek_id: number;
    public customer_id: number;
    public title: string;
    public description: string;
    public rating: number;
    public is_published: boolean;
    public published_by_id: number;
    public published_date: string;
    public review_date: string;
    public review_time: string;
    public created_at: string;
    public updated_at: string;
    public customer: CustomerModel = new CustomerModel({});

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.trek_id = obj.trek_id ? obj.trek_id : 0;
        this.customer_id = obj.customer_id ? obj.customer_id : 0;
        this.title = obj.title ? obj.title : '';
        this.description = obj.description ? obj.description : '';
        this.rating = obj.rating ? obj.rating : 0;
        this.is_published = obj.is_published ? obj.is_published : 0;
        this.description = obj.description ? obj.description : '';
        this.published_by_id = obj.published_by_id ? obj.published_by_id : 0;
        this.published_date = obj.published_date ? obj.published_date : '';
        this.review_date = obj.review_date ? obj.review_date : '';
        this.review_time = obj.review_time ? obj.review_time : '';
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
        this.customer = obj.customer ? obj.customer : new CustomerModel({});
    }
}
